export default "__VITE_ASSET__DnBJkiF7__"